import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import { CiWarning } from 'react-icons/ci';
import { URL_AWS } from '../../constans/servidor';
import FooterComponen from '../../components/footer';
import { Container, Row, Col, Button } from 'react-bootstrap';
import parkingImage from '../../asses/img/Mesa de trabajo 23.png';

const ProofPaymentLandingPage = () => {
  const [invoiceInfo, setInvoiceInfo] = useState(null);
  const [invoiceError, setInvoiceError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [duration, setDuration] = useState('');

  const { dataSend } = useParams();
  const parameter = dataSend.substring(1);
  console.log(parameter);

  useEffect(() => {
    axios
      .post(`${URL_AWS}/ElectronicInvoicing/getProofPayment`, { id: parameter })
      .then((res) => {
        console.log(res);
        if (res.data.statusCode === 200) {
          setInvoiceInfo(res.data.data);
          calculateDuration(
            res.data.data.fecha_inicial,
            res.data.data.fecha_final
          );
          setTimeout(() => {
            setLoading(false);
          }, 1500);
        } else {
          setInvoiceError(true);
          setTimeout(() => {
            setLoading(false);
          }, 1500);
        }
      })
      .catch((err) => {
        console.error(err);
        setInvoiceError(true);
        setTimeout(() => {
          setLoading(false);
        }, 1500);
      });
  }, [dataSend]);

  const calculateDuration = (dateStart, dateEnd) => {
    const inicio = new Date(dateStart);
    const fin = new Date(dateEnd);
    const duracion_ms = fin - inicio;

    const duracion_segundos = duracion_ms / 1000;
    const duracion_minutos = duracion_segundos / 60;
    const duracion_horas = duracion_minutos / 60;

    const horus = Math.floor(duracion_horas);
    const minutes = Math.floor(duracion_minutos % 60);
    const seconds = Math.floor(duracion_segundos % 60);

    const durationFormated = `${horus}:${minutes}:${seconds}`;

    setDuration(durationFormated);
  };

  const generatePDF = () => {
    setShowLoading(true);
    const doc = new jsPDF();
    doc.setTextColor('#90d400');
    doc.setFontSize(16);
    doc.text(50, 20, `Parking International S.A.S`);
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.text(40, 30, 'Nit 860.058.760-1');
    doc.setFontSize(10);
    doc.text(40, 40, `Resolucion de factura No. 18764030215286 De 2022-06-16.`);
    doc.text(
      40,
      45,
      `Habilita de No. ${invoiceInfo.cod_terminal}-0 al ${invoiceInfo.cod_terminal}-0 24 meses`
    );
    doc.text(40, 50, 'RESPONSABLES DE IVA Act.Ec. 5221');
    doc.text(
      40,
      60,
      `NO SOMOS GRANDES CONTRIBUYENTES DE ACUERDO AL ARTICULO 4 DE LA`
    );
    doc.text(
      40,
      65,
      `RESOLCIÓN 000105 DEL 23 DE NOVIEMBRE DE 2020. NO SOMOS AGENTE RETENEDOR DE IVA`
    );
    doc.text(
      40,
      70,
      `pq.${invoiceInfo.cod_park} - ${invoiceInfo.infoPark?.nombre_comercial}`
    );
    doc.text(40, 80, `Dirección: ${invoiceInfo.infoPark?.direccion}`);
    doc.text(
      40,
      90,
      `FACTURA DE VENTA P.O.S ${invoiceInfo.cod_terminal}-${invoiceInfo.num_factura}`
    );
    doc.text(
      40,
      100,
      `Placa: ${
        invoiceInfo.placa === null ||
        invoiceInfo.placa === undefined ||
        invoiceInfo.placa === ''
          ? 0
          : invoiceInfo.placa
      }`
    );
    doc.text(
      40,
      110,
      `Fecha de entrada: ${invoiceInfo.fecha_inicial
        .replace('T', ' ')
        .replace('.000Z', '')}`
    );
    doc.text(
      40,
      120,
      `Fecha hora expedición: ${invoiceInfo.fecha_final
        .replace('T', ' ')
        .replace('.000Z', '')}`
    );
    doc.text(40, 130, `Duración: ${duration}`);
    doc.text(40, 140, `Valor servicio: $ ${invoiceInfo.subtotal}`);
    doc.text(40, 150, `Iva: $ ${invoiceInfo.iva}`);
    doc.text(40, 160, `Total: $ ${invoiceInfo.total}`);
    doc.text(40, 170, '------Formas de Pago------');
    doc.text(
      40,
      180,
      `${
        invoiceInfo.valor_datafono !== 0 &&
        invoiceInfo !== null &&
        invoiceInfo !== undefined
          ? 'Valor Datafono:'
          : 'Valor Efectivo:'
      } ${
        invoiceInfo.valor_datafono !== 0 &&
        invoiceInfo.valor_datafono !== 0 &&
        invoiceInfo !== null &&
        invoiceInfo !== undefined
          ? invoiceInfo.valor_datafono
          : invoiceInfo.valor_ef
      }`
    );
    doc.text(
      40,
      190,
      `Total efectivo: ${
        invoiceInfo.valor_ef !== null &&
        invoiceInfo.valor_ef !== undefined &&
        invoiceInfo.valor_ef !== 0
          ? invoiceInfo.valor_ef
          : 0.0
      }`
    );
    doc.text(
      40,
      200,
      `Decreto 268/09 - parrafo 2do. la liquidación del valor final del servicio se aproximara al
      `
    );
    doc.text(40, 205, `multiplo de cincuenta pesos ($50) siguiente.`);
    doc.text(40, 210, `Este punto de servicio se encuentra con la poliza de`);
    doc.text(
      40,
      215,
      `responsabilidad Civil No. 2267 de AXA COLPATRIA SEGUROS S.A.`
    );

    doc.text(40, 225, `GRACIAS POR CONFIAR EN NUESTRO SERVICIO.`);
    doc.text(40, 240, `Cufe: Por definir`);

    setTimeout(() => {
      doc.save(
        `Comprobante de pago ${invoiceInfo.cod_terminal}-${invoiceInfo.num_factura}`
      );
      setShowLoading(false);
    }, 1500);
  };

  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      {invoiceInfo && !invoiceError ? (
        <>
          <Container className="info-invoice">
            <Row
              className="justify-content-center mtop-20 mbottom-40"
              id="contacto"
            >
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: '12px',
                  }}
                >
                  <img src={parkingImage} style={{ width: '30%' }} />
                </div>
                <h1 className="title-invoice">Parking International S.A.S</h1>
                <p
                  style={{
                    marginBottom: '7px',
                    textAlign: 'center',
                  }}
                >
                  Nit 860.058.760-1
                </p>
                <p
                  style={{
                    marginBottom: '7px',
                    textAlign: 'center',
                  }}
                >
                  Resolucion de factura No. 18764030215286 De 2022-06-16.
                  Habilita de No. {invoiceInfo.cod_terminal}-0 al{' '}
                  {invoiceInfo.cod_terminal}-0 24 meses
                </p>
                <p
                  style={{
                    marginBottom: '7px',
                    textAlign: 'center',
                  }}
                >
                  RESPONSABLES DE IVA Act.Ec. 5221
                </p>
                <p
                  style={{
                    marginBottom: '7px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  NO SOMOS GRANDES CONTRIBUYENTES DE ACUERDO AL ARTICULO 4 DE LA
                  RESOLCIÓN 000105 DEL 23 DE NOVIEMBRE DE 2020. NO SOMOS AGENTE
                  RETENEDOR DE IVA
                </p>
                <p
                  style={{
                    marginBottom: '7px',
                    textAlign: 'center',
                  }}
                >
                  pq.{invoiceInfo.cod_park} -{' '}
                  {invoiceInfo.infoPark?.nombre_comercial}
                </p>
                <p
                  style={{
                    textAlign: 'center',
                    marginBottom: '7px',
                  }}
                >
                  {invoiceInfo.infoPark?.direccion}
                </p>
                <p
                  style={{
                    textAlign: 'center',
                    marginBottom: '7px',
                  }}
                >
                  FACTURA DE VENTA SISTEMA P.O.S {invoiceInfo.cod_terminal}-
                  {invoiceInfo.num_factura}
                </p>
                <p
                  style={{
                    textAlign: 'center',
                    marginBottom: '7px',
                  }}
                >
                  Cufe: Por definir
                </p>
                <p>
                  Placa:{' '}
                  {invoiceInfo.placa === null ||
                  invoiceInfo.placa === undefined ||
                  invoiceInfo.placa === ''
                    ? 0
                    : invoiceInfo.placa}
                </p>
                <p>
                  Fecha de entrada:{' '}
                  {invoiceInfo.fecha_inicial
                    .replace('T', ' ')
                    .replace('.000Z', '')}
                </p>
                <p>
                  Fecha hora expedición:{' '}
                  {invoiceInfo.fecha_final
                    .replace('T', ' ')
                    .replace('.000Z', '')}
                </p>
                <p>Duración: {duration}</p>
                <br />
                <table className="table-invoice">
                  <tbody>
                    <tr>
                      <td>Valor servicio:</td>
                      <td>$ {invoiceInfo.subtotal}</td>
                    </tr>
                    <tr>
                      <td>Iva:</td>
                      <td>$ {invoiceInfo.iva}</td>
                    </tr>
                    <tr>
                      <td>Total:</td>
                      <td>$ {invoiceInfo.total}</td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <p style={{ display: 'flex', justifyContent: 'center' }}>
                  -----Formas de Pago------
                </p>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        {invoiceInfo.valor_datafono !== 0 &&
                        invoiceInfo !== null &&
                        invoiceInfo !== undefined
                          ? 'Valor Datafono:'
                          : 'Valor Efectivo:'}
                      </td>
                      <td>
                        ${' '}
                        {invoiceInfo.valor_datafono !== 0 &&
                        invoiceInfo.valor_datafono !== 0 &&
                        invoiceInfo !== null &&
                        invoiceInfo !== undefined
                          ? invoiceInfo.valor_datafono
                          : invoiceInfo.valor_ef}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Efectivo</td>
                      <td>
                        ${' '}
                        {invoiceInfo.valor_ef !== null &&
                        invoiceInfo.valor_ef !== undefined &&
                        invoiceInfo.valor_ef !== 0
                          ? invoiceInfo.valor_ef
                          : 0.0}
                      </td>
                    </tr>
                    {invoiceInfo.formaPago !== 'EFECTIVO' &&
                    invoiceInfo.formaPago !== 'DATAFONO' ? (
                      <tr>
                        <td>Beneficio / Descuento:</td>
                        <td>
                          {'  '}
                          {invoiceInfo.formaPago !== ''
                            ? invoiceInfo.formaPago
                            : 'No Aplica'}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
                <p
                  style={{
                    marginBottom: '7px',
                    marginTop: '7px',
                    textAlign: 'center',
                  }}
                >
                  Decreto 268/09 - parrafo 2do. la liquidación del valor final
                  del servicio se aproximara al multiplo de cincuenta pesos
                  ($50) siguiente. Este punto de servicio se encuentra con la
                  poliza de responsabilidad Civil No. 2267 de AXA COLPATRIA
                  SEGUROS S.A.
                  <br />
                  GRACIAS POR CONFIAR EN NUESTRO SERVICIO.
                  <br />
                  <br />
                  <a href="www.parking.net.co">www.parking.net.co</a>{' '}
                  <a href="mailto:servicioalcliente@parking.net.co">
                    servicioalcliente@parking.net.co
                  </a>
                </p>
              </Col>
            </Row>
            {showLoading ? (
              <div className="container-sniper"></div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button onClick={generatePDF}>Descargar Comprobante</Button>
              </div>
            )}
          </Container>
        </>
      ) : (
        <>
          <Container>
            <Row
              className="justify-content-center mtop-40 mbottom-40"
              id="contacto"
            >
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <CiWarning size="7rem" color="red" />
                  <h2>No se pudo encontrar.</h2>
                  <p>
                    Lo sentimos, no pudimos encontrar el comprobante de pago que
                    estás buscando, intentalo mas tarde.
                    <br />
                    Si necesitas ayuda, no dudes en{' '}
                    <a href="#/contacto">contactarnos</a>.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </>
      )}
      <FooterComponen />
    </>
  );
};

export default ProofPaymentLandingPage;
